import "react";
import { css as e, styled as t } from "styled-components";
import { jsx as n } from "react/jsx-runtime";
//#region src/Typography/Typography.tsx
var r = {
	h1: {
		tag: "h1",
		size: "4xl",
		lineHeight: "tight",
		defaultWeight: "bold",
		tracking: !0
	},
	h2: {
		tag: "h2",
		size: "3xl",
		lineHeight: "tight",
		defaultWeight: "bold",
		tracking: !0
	},
	h3: {
		tag: "h3",
		size: "2xl",
		lineHeight: "tight",
		defaultWeight: "semibold",
		tracking: !0
	},
	h4: {
		tag: "h4",
		size: "xl",
		lineHeight: "tight",
		defaultWeight: "semibold",
		tracking: !0
	},
	h5: {
		tag: "h5",
		size: "lg",
		lineHeight: "tight",
		defaultWeight: "semibold",
		tracking: !0
	},
	h6: {
		tag: "h6",
		size: "base",
		lineHeight: "tight",
		defaultWeight: "semibold",
		tracking: !0
	},
	title: {
		tag: "p",
		size: "lg",
		lineHeight: "tight",
		defaultWeight: "semibold"
	},
	subtitle: {
		tag: "p",
		size: "base",
		lineHeight: "normal",
		defaultWeight: "normal"
	},
	body: {
		tag: "p",
		size: "base",
		lineHeight: "normal",
		defaultWeight: "normal"
	},
	small: {
		tag: "p",
		size: "sm",
		lineHeight: "normal",
		defaultWeight: "normal"
	},
	label: {
		tag: "label",
		size: "sm",
		lineHeight: "normal",
		defaultWeight: "medium"
	},
	caption: {
		tag: "span",
		size: "xs",
		lineHeight: "normal",
		defaultWeight: "normal"
	},
	overline: {
		tag: "span",
		size: "xs",
		lineHeight: "normal",
		defaultWeight: "semibold"
	},
	code: {
		tag: "code",
		size: "sm",
		lineHeight: "normal",
		defaultWeight: "normal"
	}
}, i = (e, t) => {
	switch (e) {
		case "primary": return t.colors.foreground;
		case "secondary": return t.colors.mutedForeground;
		case "error": return t.colors.destructive;
		case "white": return "#ffffff";
		case "dimmed": return t.colors.mutedForeground + "aa";
		case "success": return t.colors.success;
		case "inherit": return "inherit";
		default: return e;
	}
}, a = t.span`
    display: ${({ $inline: e }) => e ? "inline" : "block"};
    margin: 0;
    font-family: ${({ theme: e, $isCode: t }) => t ? "ui-monospace, 'Cascadia Code', 'Source Code Pro', monospace" : e.typographyTokens.fontFamily};
    font-size: ${({ theme: e, $variant: t, $fontSize: n }) => n === void 0 ? e.typographyTokens.sizes[r[t].size] : typeof n == "number" ? `${n}px` : n};
    line-height: ${({ theme: e, $variant: t }) => e.typographyTokens.lineHeights[r[t].lineHeight]};
    color: ${({ theme: e, $color: t }) => i(t, e)};
    font-weight: ${({ theme: e, $weight: t }) => e.typographyTokens.weights[t]};
    text-align: ${({ $align: e }) => e};

    /* heading letter-spacing */
    ${({ $variant: t }) => r[t].tracking && e`
            letter-spacing: -0.02em;
        `}

    /* overline transform */
    ${({ $variant: t }) => t === "overline" && e`
            text-transform: uppercase;
            letter-spacing: 0.08em;
        `}

    /* code block */
    ${({ $isCode: t, theme: n }) => t && e`
            background: ${n.colors.accent};
            padding: 0.15em 0.4em;
            border-radius: ${n.radii.sm};
        `}

    /* line-clamp */
    ${({ $clamp: t }) => t && e`
            display: -webkit-box;
            -webkit-line-clamp: ${t};
            -webkit-box-orient: vertical;
            overflow: hidden;
        `}
`, o = ({ children: e, className: t, style: i, variant: o = "body", color: s = "primary", weight: c, align: l = "left", fontSize: u, as: d, clamp: f, inline: p, id: m, htmlFor: h }) => {
	let g = r[o], _ = c ?? g.defaultWeight;
	return /* @__PURE__ */ n(a, {
		as: d ?? g.tag,
		className: t,
		style: i,
		$variant: o,
		$color: s,
		$weight: _,
		$align: l,
		$fontSize: u,
		$clamp: f,
		$inline: p,
		$isCode: o === "code",
		id: m,
		htmlFor: h,
		children: e
	});
}, s = (e) => /* @__PURE__ */ n(o, {
	variant: "h1",
	...e
}), c = (e) => /* @__PURE__ */ n(o, {
	variant: "h2",
	...e
}), l = (e) => /* @__PURE__ */ n(o, {
	variant: "h3",
	...e
}), u = (e) => /* @__PURE__ */ n(o, {
	variant: "h4",
	...e
}), d = (e) => /* @__PURE__ */ n(o, {
	variant: "h5",
	...e
}), f = (e) => /* @__PURE__ */ n(o, {
	variant: "h6",
	...e
}), p = (e) => /* @__PURE__ */ n(o, {
	variant: "title",
	...e
}), m = (e) => /* @__PURE__ */ n(o, {
	variant: "subtitle",
	color: "secondary",
	...e
}), h = (e) => /* @__PURE__ */ n(o, {
	variant: "body",
	...e
}), g = (e) => /* @__PURE__ */ n(o, {
	variant: "small",
	color: "secondary",
	...e
}), _ = (e) => /* @__PURE__ */ n(o, {
	variant: "label",
	...e
}), v = (e) => /* @__PURE__ */ n(o, {
	variant: "caption",
	color: "secondary",
	...e
}), y = (e) => /* @__PURE__ */ n(o, {
	variant: "overline",
	color: "secondary",
	...e
}), b = (e) => /* @__PURE__ */ n(o, {
	variant: "code",
	...e
});
//#endregion
export { h as Body, v as Caption, b as Code, s as H1, c as H2, l as H3, u as H4, d as H5, f as H6, _ as Label, y as Overline, g as Small, m as Subtitle, p as Title, o as Typography };
